import {createSlice} from '@reduxjs/toolkit';

import {API_REDUCER_STATE_ID} from './api_constants';
import {ApiParams, FilteredPayloadAction, reducerUtils} from 'src/js/common';

interface ApiState {
  apiParameters: ApiParams;
}

const initialState: ApiState = {
  apiParameters: {},
};

export const apiSlice = createSlice({
  name: API_REDUCER_STATE_ID,
  initialState,
  reducers: {
    changeApiParams: {
      reducer(state, action: FilteredPayloadAction<ApiParams>) {
        state.apiParameters = {
          ...state.apiParameters,
          ...action.payload,
        };
      },
      prepare: reducerUtils.prepareWithStateIdFactory<ApiParams>(),
    },
  },
});
